// --------------------------------------------------------
// src/views/book.view.js
//
// Manage the view/template of a book object
//
// --------------------------------------------------------
"use strict";

const AUTHOR_TEMPLATE = `
    <%= this.model.get("name") %>
`;

// The view for a single book model
const AuthorComponent = Backbone.View.extend({

	// The DOM element that will be created
	tagName: "li",

	// Render the template
	render: function() {
		var tmpl = this.template(this);
        this.$el.html(tmpl);

		return this;
	},

	// Convert the template to html
	template: _.template( AUTHOR_TEMPLATE ),

});